import React, { useContext } from 'react';
import { Collapse, Nav, Navbar } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import { navbarBreakPoint } from '../../config';
import Logo from './Logo';
import NavbarVerticalMenu from './NavbarVerticalMenu';
import AppContext from '../../context/Context';
import useAdminNavigationRoutes from '../../hooks/useAdminNavigationRoutes';

const isBurgerMenuShown = () => {
  const burgerMenu = document.getElementById('burgerMenu');
  if (!burgerMenu) {
    return false;
  }

  return !(getComputedStyle(burgerMenu).display === 'none');
};

const NavbarVertical = () => {
  const { showBurgerMenu, setShowBurgerMenu, user, isSidebarCollapsed } = useContext(AppContext);
  const routes = useAdminNavigationRoutes();

  const handleNavbarVerticalCollapse = () => isBurgerMenuShown() && setShowBurgerMenu(!showBurgerMenu);

  return (
    <Navbar
      expand={navbarBreakPoint}
      className={classNames('navbar-vertical navbar-glass psi-navbar-vertical med-navbar-vertical', {
        'is-collapsed': isSidebarCollapsed
      })}
      light
    >
      <div className="psi-navbar-brand-wrap">
        <div className="psi-navbar-brand-head">
          <Logo at="navbar-vertical" className="psi-navbar-brand" />
        </div>
        <div className="psi-navbar-role-pill">{user?.role_label || 'Psixolog boshqaruv'}</div>
      </div>
      <Collapse navbar isOpen={showBurgerMenu}>
        <div className="psi-navbar-vertical-body med-navbar-vertical-body">
          <div className="psi-navbar-user-card med-navbar-user-card">
            <div className="psi-navbar-user-avatar med-navbar-user-avatar">{(user?.full_name || 'P').charAt(0)}</div>
            <div className="psi-navbar-user-copy med-navbar-user-copy">
              <strong>{user?.full_name || 'Foydalanuvchi'}</strong>
              <span>{user?.job_title || user?.role_label || 'Psixolog modul'}</span>
            </div>
            <span className="med-navbar-user-pulse">
              <FontAwesomeIcon icon="check-circle" />
            </span>
          </div>
          <Nav navbar vertical>
            <NavbarVerticalMenu
              routes={routes}
              handleNavbarVerticalCollapse={handleNavbarVerticalCollapse}
              isSidebarCollapsed={isSidebarCollapsed}
            />
          </Nav>
        </div>
      </Collapse>
    </Navbar>
  );
};

export default NavbarVertical;
